import { ErrorMessage } from "formik";
import React, { useEffect } from "react";

export default function TextInput({ field, form, ...props }) {
  useEffect(() => {
    if (props.resetValue) {
      form.setFieldValue(field.name, null)
    }
  }, [props.resetValue]);
  return (
    <div
      className={"form-group input-group-lg col-md-" + (props.colNumber || 4)}
    >
      <label className="text-black font-w600">
        {props.title ===undefined ? props.label: props.title ===""? <br/>: props.title}
        {props.required ? "*" : ""}
      </label>
      <input
        type="text"
        className="form-control"
        placeholder={props.label}
        style={{ height: "calc(1.5em + 1rem + -4px)" }}
        autoComplete="on"
        {...field}
        {...props}
        value={field.value ? field.value : ""}
        onChange={(e) => {
          form.setFieldValue(field.name, e.target.value);          
          if(props.onlyEnglish){
            form.setFieldValue(field.name, e.target.value.replace(/[^A-Za-z\s0-9]/ig, ''));            
          }          
          if (props.onChangeFunc) {
            props.onChangeFunc(e.target.value);
          }
        }}
      />
      <ErrorMessage
        name={field.name}
        render={(msg) => (
          <span className="text-danger">
            <small>*{msg}</small>
          </span>
        )}
      />
    </div>
  );
}
